import TargetingProvider from '@/contexts/Targeting/TargetingProvider';
import { AudienceTargeting } from './AudienceTargeting';

import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';
import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  baseCurrency: BaseCurrencyInterface;
  onChange: (targeting: TargetingBaseType) => void;
  targeting: TargetingBaseType;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function AudienceTargetingWrapper({ baseCurrency, onChange, targeting, user, userRoles }: Props) {
  return (
    <TargetingProvider onChange={onChange} targeting={targeting} user={user} userRoles={userRoles}>
      <AudienceTargeting baseCurrency={baseCurrency} />
    </TargetingProvider>
  );
}

export default AudienceTargetingWrapper;
